module.exports = __webpack_public_path__ + "static/media/view payslip.4c509071.svg";